import React from 'react'
import { useState } from 'react'
import { useToaster } from '@enterprise-ui/canvas-ui-react'
import { SideNavigation, itemCommonUtilis } from 'item-component'
import {
  getSideNavAppMenus,
  getSideNavDynamicMenus,
  itemHubApiKey,
} from '../globalConfig/sideNavConfig'
import { VendorContext } from '../globalState/Vendor'
import { SavedViewContext } from '../globalState/SavedViews'
import fileDownload from 'js-file-download'
import { downloadSavedView } from '../services/requests'
import { TOASTER_DEFAULTS, ROUTER_BASENAME } from '../globalConfig/constants'
import { NavLink, useLocation } from 'react-router-dom'

export const SideNavigationWrapper = (props) => {
  const makeToast = useToaster()
  const location = useLocation()
  const [loadingSavedViews, setLoadingSavedViews] = useState([])
  const [vendorState] = React.useContext(VendorContext)
  const [savedViewState] = React.useContext(SavedViewContext)

  const makeDownloadSavedViewRequest = (savedView, index) => {
    setLoadingSavedViews((oldArray) => [...oldArray, index])
    downloadSavedView(savedView.viewId, vendorState?.selectedVendor)
      .then((response) => {
        setLoadingSavedViews((oldArray) =>
          oldArray.filter((value) => value !== index),
        )
        if (response?.status === 200) {
          const fileName = `${
            savedView?.title
          } ${new Date().toLocaleString()}.xlsx`
            .replaceAll('/', '-')
            .replaceAll(':', '_')
          fileDownload(response.data, fileName)
          makeToast({
            ...TOASTER_DEFAULTS,
            type: 'success',
            heading: 'Download Successful',
            message: `"${fileName}" successfully downloaded`,
          })
        } else {
          makeToast({
            ...TOASTER_DEFAULTS,
            type: 'error',
            heading: 'Download Failed',
            message: 'Failed to download your saved view.',
          })
        }
      })
      .catch(() => {
        setLoadingSavedViews((oldArray) =>
          oldArray.filter((value) => value !== index),
        )
        makeToast({
          ...TOASTER_DEFAULTS,
          type: 'error',
          heading: 'Download Failed',
          message: 'Failed to download your saved view.',
        })
      })
  }

  return (
    <SideNavigation
      className="side-navigation-panel"
      data-testid="item-app-sidenav-panel"
      startExpanded
      appMenus={getSideNavAppMenus(
        savedViewState?.savedViews,
        loadingSavedViews,
        makeDownloadSavedViewRequest,
      )}
      dynamicMenus={getSideNavDynamicMenus(
        savedViewState?.savedViews,
        loadingSavedViews,
        makeDownloadSavedViewRequest,
      )}
      defaultmenurequired={itemCommonUtilis?.isItemHub}
      isMinimized={false}
      clientApp="icm"
      itemHubApiKey={itemHubApiKey}
      LinkComponent={NavLink}
      currentPath={`${ROUTER_BASENAME}${location.pathname}`}
    />
  )
}
